import { HStack, Image, Text } from '@chakra-ui/react';
import { NavLink } from 'react-router';

export const HomeLink = () => (
  <NavLink to="/">
    <HStack gap={1}>
      <Image src="/assets/hub-logo-feather.svg" />
      <Text fontSize="17.5px" fontWeight="800" lineHeight="24.5px" letterSpacing="-0.7px">
        portal
      </Text>
    </HStack>
  </NavLink>
);
